import React from "react"
import "./userProfileContent.scss"
import UserProfileInfo from "../userProfileInfo/userProfileInfo"
import UserProfilePosts from "../userProfilePosts/userProfilePosts"
import UserProfileKnowCred from "../userProfileKnowcred/userProfileKnowCred"
import ErrorBoundary from "../../../../../components/v2/ErrorBoundary"

const UserProfileContent = (props) => {
  const { userInfo, type } = props

  return (
    <div className="profile-container">
      <ErrorBoundary>
        <UserProfileInfo type={type} />
      </ErrorBoundary>
      <UserProfileKnowCred userInfo={userInfo} type={type} />
      <UserProfilePosts userInfo={userInfo} {...props} />
    </div>
  )
}

export default UserProfileContent
